import React, { useState, useEffect, useCallback } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import RootStack from './navigators/RootStack';
import BottomTabNav from './navigators/BottomTabNav';

import { StatusBar } from 'expo-status-bar';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from './components/CredentialsContext';
import NewUserNavigator from './navigators/NewUserNavigator';

// LogBox.ignoreAllLogs()
export default function App() { 

  const [appReady, setAppReady] = useState(false);
  const [storedCredentials, setStoredCredentials] = useState("");

  useEffect(() => {

    AsyncStorage.getItem('flowerCribCredentials')
    .then((result)=>{

      if(result !== null){
        setStoredCredentials(JSON.parse(result));
        setAppReady(true);
      } else {
        setStoredCredentials(null);
        setAppReady(true);
      }

      
    })
    .catch(err => console.log(err))

  }, []);

  const handleScreen = storedCredentials => {
    if(storedCredentials && storedCredentials.userRooms){
      // return <RootStack />
      return <BottomTabNav />
    } else {
      return <NewUserNavigator />
    }
  }

  if(!appReady) {
    return (
      <SafeAreaProvider>
        <View style={{flex:1, justifyContent: 'center', alignItems: 'center'}}>
          <StatusBar />
          <ActivityIndicator size='large' />
        </View>
      </SafeAreaProvider>
    ) 
  }
  return (
    <SafeAreaProvider>
      <CredentialsContext.Provider value={{storedCredentials, setStoredCredentials}}>
        {handleScreen(storedCredentials)}
      </CredentialsContext.Provider>
    </SafeAreaProvider>
    
  )
  

};
